import {
    Component,
    forwardRef,
    Input,
    Inject,
    Output,
    EventEmitter,
} from "@angular/core";

import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { AlertController } from "@ionic/angular";
import { HomeController } from "@shared/src/controllers/home/home.controller";
import { UpdateDeliveryLinesDialogDialogComponent } from "./dialog/updatedeliverylinesdialog.dialog.component";
import { Route_eCMRDto } from "@shared/src/dtos/route/cmr/Route_eCMRDto";
import { RouteCMRController } from "@shared/src/controllers/route/cmr/routecmr.controller";

export const SharedUpdateDeliveryLinesDialogComponent_NOSEPERQUESERVEIXA: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UpdateDeliveryLinesDialogDialogComponent),
    multi: true,
};

@Component({
    selector: "updatedeliverylines-dialog",
    templateUrl: "./shared.updatedeliverylinesdialog.component.html",
    styleUrls: ["./shared.updatedeliverylinesdialog.component.scss"],
    providers: [SharedUpdateDeliveryLinesDialogComponent_NOSEPERQUESERVEIXA],
})
export class SharedUpdateDeliveryLinesDialogComponent {
    @Output() public onConfirm: EventEmitter<boolean> =
        new EventEmitter<boolean>();
    @Output() public onCancel: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Input() title: string = "";
    @Input() paramstitle: any;

    @Input() routePartCMRId: number;
    /*** Línies + tots els totals del CMR: es passa sencer per no haver-nos d'anar recordant camp a camp */
    @Input() route_eCMR: Route_eCMRDto;
    @Input() external: boolean;

    private _expanded: boolean = false;
    @Input() public set expanded(value: boolean) {
        if (value)
            this.clickHelpNoIonic();

        this._expanded = value;
    }

    public get expanded(): boolean {
        return this._expanded;
    }

    public useIonic: boolean = false;

    public position = "below";

    constructor(
        private translate: TranslateService,
        private mdDialog: MatDialog,
        private alertController: AlertController,
        private ecmrController: RouteCMRController,
        @Inject("HomeController") protected homecontroller: HomeController
    ) {
        if (homecontroller.useIonic) this.useIonic = homecontroller.useIonic();
    }

    ngOnInit() { }

    clickHelpNoIonic() {
        let dialog = this.mdDialog.open(UpdateDeliveryLinesDialogDialogComponent, {
            disableClose: true,
            width: "900px",
            data: {
                title: this.gettitle(),
                route_eCMR: this.route_eCMR,
                routePartCMRId: this.routePartCMRId,
                external: this.external
            },
        });

        dialog.backdropClick().subscribe((data) => {
            this.onCancel.next(true);
        });

        dialog.componentInstance.onResolve.subscribe((data: boolean) => {
            if (data) this.onConfirm.next(true);
            else this.onCancel.next(true);
        });

        this.mdDialog.afterAllClosed.subscribe(() => { });
    }

    gettitle() {
        if (this.title != null && this.title != "")
            return this.translate.instant(
                this.title,
                this.paramstitle
            );

        return "";
    }
}
